import { ytVueGlobalStore } from "@/services/yt-vue-global-store.js";

export default {
  namespaced: true,
  state: {
    ...ytVueGlobalStore.instantGet("serp-detail"),
  },
};
